import {Injectable} from '@angular/core';
import {UserService} from './user.service';
import {SubscriptionsService} from './subscriptions.service';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class GameLauncherService {
    gameId: any;
    minBet: any;
    gameBackground: any;
    screen: any;
    error: any;
    url: any;
    language: any;

    constructor(public userService: UserService,
                public subscriptionsService: SubscriptionsService,
                public lotteryService: LotteriesService,
                public router: Router) {
        this.subscriptionsService.getGameBackground().subscribe(url => {
            this.gameBackground = url;
            localStorage.setItem('gameBackground', this.gameBackground);
        });
    }

    runGame(gameId, minBet) {
        this.gameId = gameId;
        this.minBet = minBet;
        this.subscriptionsService.emitGameBackground(this.gameBackground);
        return new Promise((resolve) => {
            this.userService.getUser();
            if (!this.userService.userData) {
                resolve('noUser');
                this.subscriptionsService.emitRegisterOrLogin(true);
                if (gameId) {
                    this.subscriptionsService.emitCurrentGameId(gameId);
                } else {
                    this.subscriptionsService.emitCurrentGameId('-1');
                }
            } else {
                this.userService.checkStatus(this.userService.userData.Status).then((val) => {
                    let mobile = false;
                    if (window && (window.navigator.userAgent.includes('iPad') || window.navigator.userAgent.includes('iPhone'))) {
                        mobile = true;
                    } else {
                        mobile = this.lotteryService.isMobile;
                    }
                    if (val === 'noRedirect') {
                        this.language = localStorage.getItem('pageLanguage');
                        const gameData = 'sessionId=' + this.userService.userData.sessionId + '&gameId=' + gameId +
                            '&language=' + this.language + '&isMobile=' + mobile;
                        this.lotteryService.postData(globals.appDomain + '/instantGames/startGameSession/' +
                            'startGameSession_gameLauncher.json', gameData).subscribe(
                            result => {
                                window.location.hash = '';
                                if (!result.message.ErrorID) {
                                    this.screen = result.message.Fullscreen;
                                    this.error = -1;
                                    this.url = result.message.EmbedUrl;
                                    this.gameId = gameId;
                                    setTimeout(() => {
                                        resolve('startGame');
                                        this.subscriptionsService.emitStartInstant(gameId);
                                        this.gameId = -1;
                                        this.minBet = undefined;
                                        this.gameBackground = '';
                                    }, 300);
                                } else {
                                    if (result.message.ErrorID === '102') {
                                        setTimeout(() => {
                                            this.subscriptionsService.forceOpen = true;
                                            this.subscriptionsService.emitUserNeedIncreseBalance(gameId);
                                        }, 1200);
                                    } else if (result.message.ErrorID === '069') {
                                        localStorage.setItem('dashboardStatus', 'verification');
                                        this.router.navigate(['/' + this.language, 'dashboard']);
                                    } else if (result.message.ErrorID === '1042') {
                                        this.subscriptionsService.updateOpenUniversalJinniErrorModal(true);
                                        this.subscriptionsService.updateUniversalJinniErrorModalData(1042);
                                    } else if (result.message.ErrorID === '10426') {
                                        this.subscriptionsService.updateOpenUniversalJinniErrorModal(true);
                                        this.subscriptionsService.updateUniversalJinniErrorModalData(10426);
                                    } else if (result.message.ErrorID !== '102') {
                                        this.subscriptionsService.updateOpenUniversalJinniErrorModal(true);
                                        this.subscriptionsService.updateUniversalJinniErrorModalData(0);
                                    }
                                }
                            }
                        );
                    } else if (val === 'redirect') {
                        this.subscriptionsService.emitStartInstant('off');
                        this.subscriptionsService.emitFakeCart(false);
                    }
                });


            }
        });
    }
}
